var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ee5050;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 118,
    height: 118,
    rx: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.714 25.03)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M150.714,249.777a4.222,4.222,0,0,0-5.953,0l-9.711,9.711-18.112-18.112a4.222,4.222,0,0,0-5.953,0L81.432,270.929a4.222,4.222,0,0,0,2.955,7.177h84.439a4.222,4.222,0,0,0,3-7.22Z",
    transform: "translate(-80.225 -210.554)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 12.655,
    cy: 12.655,
    r: 12.655,
    transform: "translate(46.417)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.85ddb393911e58195236460e445764ea.svg";
export { ForwardRef as ReactComponent };